import React from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Grid, Box } from '@mui/material'
import { TextField, ModelMenuSelectorField, ModelAutocompleteField, DateField, SingleOptionSelectorField } from '@front/squirtle'


const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField
        label={I18n.t('vehicle.plaque')}
        name='info.plaque'
      />
    </Grid>
    <Grid size="grow">
      <ModelAutocompleteField
        label={I18n.t('vehicle.brand', { count: 1 })}
        name='brand'
        model_name={'vehiclebrand'}
        labelKeys={['name']}
        autocompleteKey={'name'}
        searchMode={'search'}
        config={{ initial_filter: {} }}
        loadOnFocus={false}
      />
    </Grid>
    <Grid size="grow">
      <ModelAutocompleteField
        label={I18n.t('vehicle.model', { count: 1 })}
        name='model'
        model_name={'vehiclemodel'}
        labelKeys={['name']}
        autocompleteKey={'name'}
        searchMode={'search'}
        config={{ initial_filter: {} }}
        loadOnFocus={false}
      />
    </Grid>
    <Grid size="grow">
      <DateField
        label={I18n.t('vehicle.in_service')}
        name='info.in_service_date'
        inputFormat={'DD/MM/YYYY'}
      />
    </Grid>
  </Grid>

const Row2 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size={2}>
      <TextField
        label={I18n.t('contract.license_id')}
        name='parent_license.license_number'
      />
    </Grid>
    <Grid size={2}>
      <TextField
        label={I18n.t('contract.id')}
        name='parent_license.license_client_id'
      />
    </Grid>
    <Grid size={6}>
      <ModelMenuSelectorField
        label={I18n.t('options.label', { count: 2 })}
        name='options'
        model_name='vehicleoption'
        config={{
          initial_filter: {}
        }}
        searchMode='search'
        labelKeys={['name_translated']}
        multiple
        allowNone={false}
      />
    </Grid>
    <Grid size={3}>
      <ModelMenuSelectorField
        label={I18n.t('vehicletype.label', { count: 2 })}
        name='type'
        model_name='vehicletype'
        config={{
          initial_filter: {}
        }}
        searchMode='search'
        labelKeys={['name_translated']}
        multiple
        allowNone={false}
      />
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField name='active' label={I18n.t('active')} />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Grid size={9}>
        <Typography variant={'h5'}>{I18n.t('vehicle.search')}</Typography>
      </Grid>
      <Row1 />
      <Row2 />
    </Grid>
  </Box>
export default React.memo(SearchForm)
